import React from 'react';

const NewHeroCarouselSlideSix = () => {
  return <div className='carousel__slide-box carousel__box-six'></div>;
};

export default NewHeroCarouselSlideSix;
